import * as React from "react";
import { useState, useEffect } from "react";
import HamburgerMenu from "../../components/menu/HamburgerMenu";
import { menuItems } from "../../components/menu/MenuContent";
import InlineMenu from "../../components/menu/InlineMenu";
import TopNavBarLogo from "./TopNavBarLogo";
import ReserveAppointmentButton from "../../components/Buttons/ReserveAppointmentButton";

export const TopNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <div
        className={`
          flex items-center
          transition-all duration-700
          ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"}
        `}
      >
        <TopNavBarLogo />
      </div>
      <div
        className={`
          text-font-lightGrey font-semibold
          hidden xl:flex items-center
          transition-all duration-700
          ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"}
        `}
      >
        <InlineMenu menuContent={menuItems} />
        <ReserveAppointmentButton />
      </div>
      <div
        className={`
          flex xl:hidden items-center
          gap-4
          transition-all duration-700
          ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"}
        `}
      >
        <ReserveAppointmentButton />
        <HamburgerMenu
          setIsAllMenuOpen={setIsMenuOpen}
          isAllMenuOpen={isMenuOpen}
          menuContent={menuItems}
        />
      </div>

      {/* Call-to-Action Button - Always Visible */}
    </>
  );
};
